module.exports = require("core-js/library/fn/number/is-nan");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/number/is-nan.js
// module id = 98
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460